import { Navigate } from 'react-router-dom'
import { usePages } from '@config/site/app'

const InitialPage = () => {
  const { initialPath } = usePages()
  return <Navigate to={initialPath} />
}

export default InitialPage
